import React from "react";
import { IconButton, lighten, TextField, Theme, Toolbar, Tooltip, Typography } from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import FilterListIcon from '@mui/icons-material/FilterList';
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const useToolbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
        },
        highlight:
            theme.palette.mode === 'light'
                ? {
                    color: theme.palette.secondary.main,
                    backgroundColor: lighten(theme.palette.secondary.light, 0.85),
                }
                : {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.secondary.dark,
                },
        title: {
            flex: '1 1 100%',
        },
    }),
);

interface EnhancedTableToolbarProps {
    title: string;
    itemsFilterChanged: any;
}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const classes = useToolbarStyles();
    const { t } = useTranslation("common");
    // const { numSelected } = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: false,
            })}
        >
            {props.title ? (<Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                {props.title}
            </Typography>) : <></>}

            <TextField label={t("commonLabels.filter")} id="itemfilter" onChange={props.itemsFilterChanged} />
            <Tooltip title={t("commonLabels.filter")}>
                <IconButton aria-label="filter list" size="large">
                    <FilterListIcon />
                </IconButton>
            </Tooltip>

        </Toolbar>
    );
}

export default EnhancedTableToolbar;